const app = require('../../../../../Scripts/aem/app');
module.exports = function ($state) {
    return {
        restrict: 'E',
        scope: {
            path: '@'
        },
        controller: [
            '$scope', 'AemPortalService', 'AtmService', 'Restangular', '$element', '$rootScope', 'AtmGlobalContextService', 'RouteService',
            function($scope, aemPortalService, atmService, restangular, $element, $rootScope, atmGlobalContextService, routeService) {
                $scope.routeService = routeService;
                $scope.makeScript = aemPortalService.makeScript;

                // listen for events from AEM
                $scope.listenForEvent = function (name, callback) {
                    const viewers = $element.find('#bws-aem-viewer-xf');
                    if (viewers.length > 0) {
                        const element = viewers[0];
                        const listenerSetIdentifier = 'listener' + name.replace(/\W/g, '');
                        if (element.getAttribute(listenerSetIdentifier) !== 'true') {
                            element.addEventListener(name, callback, true);
                            element.setAttribute(listenerSetIdentifier, 'true');
                        }
                    }
                };

                let callbackListeners = [];
                // register callback with aem and rootscope
                $scope.registerCallback = (rootscopeListenerName, aemListenerName) => {
                    let callback;
                    let tempResponse;
                    if (sessionStorage.getItem(aemListenerName) !== null) {
                        tempResponse = JSON.parse(sessionStorage.getItem(aemListenerName));
                    }
                    callbackListeners.push($rootScope.$on(rootscopeListenerName, function (_e, response) {
                        if (callback) {
                            callback(response);
                        } else {
                            tempResponse = response;
                        }

                        if (response) {
                            sessionStorage.setItem(aemListenerName, JSON.stringify(response));
                        }
                    }));
                    $scope.listenForEvent(aemListenerName, (e) => {
                        if (e) {
                            callback = e.detail;
                        }
                        if (tempResponse) {
                            callback(tempResponse);
                            tempResponse = undefined;
                        }
                    });
                };

                $scope.jsPath = `/Scripts/aem`;
                $scope.restHost = aemPortalService.getRestHost();
                $scope.folder = 'web';
                $scope.dataHost = restangular.configuration.baseUrl;

                $scope.registerCallback('shopper:init', 'shopperUpdated');
                $scope.registerCallback('store:update', 'storeUpdated');

                $scope.postScriptInit = () => {
                    let currentPage;
                    $scope.listenForEvent('aem-analytics-event', (e) => {
                        if (e.detail && e.detail.event === 'pageUpdate' && e.detail.eventContext && e.detail.eventContext.pageID &&
                                $state.current && $state.current.data && $state.current.data.isAEM) {
                            if (currentPage) {
                                atmGlobalContextService.previousPageName = `bws:${currentPage}`;
                            }
                            currentPage = e.detail.eventContext.pageID;
                            $state.current.data.analytics = `bws:${currentPage}`;
                            delete e.detail.eventContext.pageID;
                        }
                        atmService.push(e.detail);
                    });
                };

                $scope.$on('$destroy', function() {
                    if (callbackListeners) {
                        callbackListeners.forEach(callbackListener => callbackListener());
                        callbackListeners = [];
                    }
                });
            }
        ],
        link(scope, _element, attributes) {
            if (attributes.project) {
                scope.project = attributes.project;
            }

            if (attributes.isPartial) {
                scope.partial = attributes.isPartial;
            }

            const scriptName = 'aemAngular';
            const scriptNotLoaded = !document.querySelector(`#${scriptName}`);

            const overridenHost = new window.URLSearchParams(window.location.search).get('aemhost');
            if (overridenHost) {
                scope.restHost = 'https://' + overridenHost;
            }
            const env = 'single';

            if (app && app[env]) {
                if (scriptNotLoaded) {
                    scope.makeScript(scriptName, scope.jsPath + '/' + app[env]);
                }
                scope.postScriptInit();
            }
        },
        template: require('./aem-portal-xf-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/aem/aem-portal-xf-directive.js
 **/